// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const ORDER_REQUEST = 'ORDER_REQUEST';

const ORDER_REQUEST_SUCCESS = 'ORDER_REQUEST_SUCCESS';
const ORDER_REQUEST_FAILED = 'ORDER_REQUEST_FAILED';

const ORDER_RESET = 'ORDER_RESET';

export {
  ORDER_REQUEST,

  ORDER_REQUEST_SUCCESS,
  ORDER_REQUEST_FAILED,

  ORDER_RESET,
};
